import { useEffect, useRef } from 'react';

const RadarScanner = () => {
  const armRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Ensure animation starts on mount
    if (armRef.current) {
      armRef.current.style.animationPlayState = 'running';
    }

    // Smooth resize handler
    const handleResize = () => {
      const container = document.querySelector('.radar-container');
      if (container) {
        (container as HTMLElement).style.transform = 'scale(1)';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="radar-section">
      <div className="radar-container">
        {/* Radar base (circular disc) */}
        <div className="radar-base">
          <div className="radar-disc">
            {/* Concentric circles */}
            <div className="radar-ring radar-ring-1"></div>
            <div className="radar-ring radar-ring-2"></div>
            <div className="radar-ring radar-ring-3"></div>
            <div className="radar-ring radar-ring-4"></div>
          </div>
        </div>
        
        {/* Rotating scanner arm */}
        <div ref={armRef} className="radar-arm"></div>
        
        {/* Moving blip for elegance */}
        <div className="radar-blip"></div>
        
        {/* Center dot */}
        <div className="radar-center"></div>
      </div>
    </section>
  );
};

export default RadarScanner;
